import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgxAimStationOverview } from './ngx-aim-station-overview.class';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'ngx-aim-station-overview',
  standalone: true,
  imports: [
    ButtonModule,
    RouterLink,
    FormsModule,
    CheckboxModule,
    InputTextareaModule,
    FloatLabelModule,
    ConfirmDialogModule,
    DialogModule,
    ProgressSpinnerModule,
    DropdownModule,
  ],
  templateUrl: './ngx-aim-station-overview.component.html',
  styleUrl: './ngx-aim-station-overview.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ConfirmationService],
})
export class NgxAimStationOverviewComponent extends NgxAimStationOverview implements OnInit {
  ngOnInit() {
    this.init();
  }
}
